/**
 * Feedback Service
 * Handles question feedback submission to the API
 */
import apiService from './apiService';

class FeedbackService {
  /**
   * Submit feedback for a question
   * @param {Object} feedbackData - The feedback data to submit
   * @param {number} feedbackData.questionId - The ID of the question
   * @param {string} feedbackData.feedback - The feedback text
   * @param {number} feedbackData.sessionId - The ID of the exam session (optional)
   * @returns {Promise<any>} - The feedback submission response
   */
  async submitFeedback(feedbackData) {
    return apiService.post('/api/feedback/question', feedbackData);
  }
}

export default new FeedbackService();
